import { Vue, Component, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { ResearchModel } from '@/models/research/research';
import { sortByProperty, copy } from '@/utils/utils';
import { researchAPI } from '@/providers/apis/research/research';

@Component({
    name: 'publications',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class Publications extends Vue {
    // ------------------------------------------------------
    // Properties

    private contentList: ResearchModel[] = [];

    private isTeamList: boolean = false;

    private activeIndex: number = -1;

    private popActiveIndex: number = -1;

    private sortOptions: any = [];

    private selectedProject: ResearchModel = {};

    private publicationData: any = {};

    private filterContent: any = {};


    /**
     * Hold the list of research projects
     */
    private researchProjects: any = [];

    @Watch('researchProjects')
    private onChangeList(value: ResearchModel[]) {
        this.contentList = value;
    }

    /**
     * Hold the list list of Categories
     */
    private get researchCategories() {
        return this.$store.getters['researchStore/categoryList'];
    }

    /**
     * Hold the list of teams
     */
    private get reasearchTeams() {
        return this.$store.getters['researchStore/teamList'];
    }


    // ------------------------------------------------------------------------------
    // Hooks

    private created() {
        this.$store.dispatch('researchStore/fetchResearchProjects');
        this.onloadPublications();
    }

    // -------------------------------------------------------------------------------------
    // Actions

    /**
     * Action trigger when click on category from research category
     * @param name
     */
    private onSelectCategory(name: string) {
        this.isTeamList = false;
        this.activeIndex = this.researchCategories.indexOf(name);
        this.publicationData.publications = name === 'all'
            ? this.filterContent.publications : this.categoriesTypes(name);
    }

    /**
     * Action trigger when click on team from research teams
     * @param name
     */
    private onSelectTools(name: string) {
        this.isTeamList = true;
        this.popActiveIndex = this.researchCategories.indexOf(name);
        this.publicationData.tools = name === 'all' ? this.filterContent.tools : this.toolTypes(name);
    }

    // --------------------------------------------------------------------------------------
    // Methods

    /**
     * Method help to get categories count based on category name
     * @param name
     */
    private categoriesTypes(name: string) {
        return copy(this.filterContent.publications).filter(
            (item: ResearchModel) => item.category === name) || [];
    }

    /**
     * Method help to get categories count based on category name
     * @param name
     */
    private toolTypes(name: string) {
        return copy(this.filterContent.tools).filter(
            (item: ResearchModel) => item.category === name) || [];
    }

    /**
     * Method help to get teams count based on team name
     * @param name
     */
    private teamsTypes(name: string) {
        return this.researchProjects.filter(
            (item: ResearchModel) => item.teams && item.teams.find(
                (team: any) => team.name === name)) || [];
    }

    private sortTable(value: any, itemName: string) {

        sortByProperty(value, itemName, 'DESC');
    }

    private onloadPublications() {
        researchAPI.fetchPublication().then((data) => {
            this.publicationData = data;
            this.filterContent = JSON.parse(JSON.stringify(data));
        });
    }
}
